import Image from 'next/image'
import React, { FC } from 'react'

import questionIcon from '@/screens/promo-iphone-17/ui/assets/question.svg'

import { createMarkup } from '@/shared/lib/utils/common/createMarkup'
import { Icon } from '@/shared/ui/icon'
import { Popover } from '@/shared/ui/Popover'

import cl from './ListSection.module.scss'

export interface ListSectionProps {
	list: { title: string; src: string; tip: string }[]
}

export const ListSection: FC<ListSectionProps> = props => {
	const { list } = props
	return (
		<section className={cl.root}>
			<h2>Причины оформить предзаказ в iPort</h2>
			<ul>
				{list.map(({ src, title, tip }) => (
					<li key={title}>
						<div className={cl.textWrap}>
							<h4 dangerouslySetInnerHTML={createMarkup(title)} />
							<Popover overlayInnerStyle={{ maxWidth: `25rem`, padding: `21px 16px` }} content={tip}>
								<Icon icon={questionIcon} width={30} height={30} />
							</Popover>
						</div>
						<Image src={src} alt={''} width={180} height={140} className={cl.img} />
					</li>
				))}
			</ul>
		</section>
	)
}
